import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { PrintNote } from './components/Chrome';
import { LangProvider } from './i18n';
import { SessionProvider } from './session';
/* order matters: faces, then tokens, then the primitives that read them, then
   the shell's layout, and last the predecessor's sheet — which is shrinking and
   whose own variables now alias the tokens */
import './design/fonts.css';
import './design/tokens.css';
import './design/primitives.css';
import './app/shell.css';
import './styles.css';

const el = document.getElementById('root');
if (!el) throw new Error('#root missing');

createRoot(el).render(
  <StrictMode>
    <LangProvider>
      <BrowserRouter>
        <SessionProvider>
          <App />
        </SessionProvider>
      </BrowserRouter>
      <PrintNote />
    </LangProvider>
  </StrictMode>,
);
